import './index.css';
const CSS_VAR_NAME = '--magritte-grid-row-gap';
const genCssVarRowGap = (props) => props.rowGap
    ? {
        [CSS_VAR_NAME]: `${props.rowGap}px`,
    }
    : undefined;

export { genCssVarRowGap };
//# sourceMappingURL=utils.js.map
